export const onConsentStudioScan = (onTrue: () => void, onFalse?: () => void) => {
    if (window.location.hash ? window.location.hash == '#cs-scan' : false) {
        onTrue();
    } else {
        onFalse?.();
    }
}